import client from '@lib/http/client'
import { CustomerTypes } from '@services/payments/useGetCustomerResource'

interface UpdateCustomerResourceDataRequest {
  name: string
  street: string
  city: string
  country: string
  postal_code: string
  tax_identifier?: string
  is_company: CustomerTypes
}

export const updateCustomerResourceData = ({
  name,
  street,
  city,
  country,
  postal_code,
  tax_identifier,
  is_company
}: UpdateCustomerResourceDataRequest) =>
  client.put('v1/payments/customers', {
    name,
    street,
    city,
    country,
    postal_code,
    tax_identifier,
    is_company
  })
